// Force reload - hooks fix
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./globals.css";
import AppContainer from "@/components/AppContainer";
import { suppressReactFlowWarnings } from "@/utils/suppress-reactflow-warnings";
import "@/utils/reset-backend"; // Make backend reset utilities available in console

// Suppress React Flow warnings in production
suppressReactFlowWarnings();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppContainer />
  </StrictMode>,
);
